import React from "react";
import { Link , NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Spinner } from "../../Loaders/Spinner/Spinner";
import "./Button.scss";

export const ButtonVariant = {
    filled: "filled",
    outline: "outline"
};

export const colorFirm = {
    firm1: 1,
    firm2: 2,
    firm3: 3,
    firm4: 4,
    firm5: 5,
    firm6: 6
};

export const Button = props => {
    const {
        children,
        className,
        disabled,
        isLoading,
        active,
        type,
        variant,
        colorFirm,
        navigation,
        ...restProps
    } = props;

    const classes = classNames(
        "btn",
        `btn--colorFirm-${colorFirm}-${variant}`,
        { "btn--is-loading": isLoading },
        { "btn--disabled": disabled },
        className
    );

    const rootProps = {
        ...restProps,
        type: type,
        className: classes,
        disabled: disabled || isLoading
    };

    const Tag = restProps.href ? "a" : "button";

    const content = (
        <>
            { children }
            { isLoading && (
                <Spinner className="btn__spinner" />
            ) }
        </>
    );

    if(navigation){
        return <NavLink {...rootProps}>{content}</NavLink>;
    }

    return restProps.to ? <Link {...rootProps}>{content}</Link> : <Tag {...rootProps}>{content}</Tag>;
};

Button.defaultProps = {
    children: null,
    className: null,
    variant: ButtonVariant.filled,
    colorFirm: colorFirm.firm1,
    disabled: false,
    active: false,
    navigation: false,
    to: undefined,
    type: "button"
};

Button.propTypes = {
    disabled: PropTypes.bool,
    navigation: PropTypes.bool,
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    variant: PropTypes.string,
    colorFirm: PropTypes.number,
    children: PropTypes.node.isRequired
};
